(function() {
    const originalAdd = EventTarget.prototype.addEventListener;

    EventTarget.prototype.addEventListener = function(type, listener, options) {
        if (type === "click") {
          const isSubmitButton =
                (this.tagName === "BUTTON" && this.type === "submit") ||
                (this.tagName === "INPUT" && this.type === "submit");
          
            if(!isSubmitButton || this.dataset.emptyFieldsRemoverAttached) {
              return originalAdd.call(this, type, listener, options);
            }
          
            const form = this.form || this.closest("form");
            if(!form) {
              return originalAdd.call(this, type, listener, options);
            }
          
            console.log("Creating wrapped fn for form submit button");
          
            const wrapped = function(event) {
                const uploadcareInputs = form.querySelectorAll(
                    "[data-uploadcare=true] input, [data-uploadcare=true] select, [data-uploadcare=true] button");
              
                if(uploadcareInputs.length < 1) {
                    console.log("The form doesn't contain any uploadcare inputs. Calling only provided listener")
                    return listener.call(this, event);
                }
              
                const keepsafe = document.createElement("div");
                keepsafe.style.width = "0";
                keepsafe.style.height = "0";
                keepsafe.style.overflow = "hidden";
                form.parentNode.insertBefore(keepsafe, form);

                let removedInputs = 0;
                uploadcareInputs.forEach(input => {
                    if(!input.name || input.name.length === 0) {
                        const dummyDiv = document.createElement("div");
                        dummyDiv.dataset.dummy = "true";
                        input.parentNode.insertBefore(dummyDiv, input);
                        keepsafe.appendChild(input);
                        removedInputs++;
                    }
                });
                  
                console.log(`Removed ${removedInputs} inputs, now calling other handlers`)
                  
                const actualReturnValue = listener.call(this, event);
                  
                console.log("Other handlers done, restoring uploadcare inputs")
                  
                const placeholderInputs = form.querySelectorAll("div[data-dummy='true']");

                const keepsafeInputs = keepsafe.querySelectorAll("input, select, button");

                let restoredInputs = 0;
                placeholderInputs.forEach((input, i) => {
                    input.parentNode.insertBefore(keepsafeInputs[i], input);
                    input.parentNode.removeChild(input);
                    restoredInputs++;
                });
                  
                console.log(`Restored ${restoredInputs} inputs. Work done`)
                  
                this.dataset.ourSubmitWrapped = "true";
                
                return actualReturnValue;
            };
          return originalAdd.call(this, type, wrapped, options);
        }

        return originalAdd.call(this, type, listener, options);
    };
})();
  
  document.addEventListener('DOMContentLoaded', () => {
        console.log('Applying standard empty fields remover script!');
        const allFormsWithUploadcare = document.querySelectorAll('form:has([data-uploadcare=true])');
        allFormsWithUploadcare.forEach(form => {
            form.addEventListener('submit', event => {
                const uploadcareInputs = form.querySelectorAll(
                  "[data-uploadcare=true] input, [data-uploadcare=true] select, [data-uploadcare=true] button"
                );

                const keepsafe = document.createElement("div");
                keepsafe.style.width = "0";
                keepsafe.style.height = "0";
                keepsafe.style.overflow = "hidden";
                form.parentNode.insertBefore(keepsafe, form);

                let removedInputs = 0;
                uploadcareInputs.forEach(input => {
                    if(!input.name || input.name.length === 0) {
                        const dummyDiv = document.createElement("div");
                        dummyDiv.dataset.dummy = "true";
                        input.parentNode.insertBefore(dummyDiv, input);
                        keepsafe.appendChild(input);
                        removedInputs++;
                    }
                });


                setTimeout(() => {
                    const placeholderInputs = form.querySelectorAll("div[data-dummy='true']");

                    const keepsafeInputs = keepsafe.querySelectorAll("input, select, button");

                    let restoredInputs = 0;
                    placeholderInputs.forEach((input, i) => {
                        input.parentNode.insertBefore(keepsafeInputs[i], input);
                        input.parentNode.removeChild(input);
                        restoredInputs++;
                    });

                }, 100)
            })
        })
    });